// extracted by mini-css-extract-plugin
module.exports = {"Median":"Median__3JE-c"};